import { render, staticRenderFns } from "./BoxValue.vue?vue&type=template&id=ff37ef1e&scoped=true&"
import script from "./BoxValue.vue?vue&type=script&lang=js&"
export * from "./BoxValue.vue?vue&type=script&lang=js&"
import style0 from "./BoxValue.vue?vue&type=style&index=0&id=ff37ef1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff37ef1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VToolbar,VToolbarTitle})
